import './strap-teaser.scss';
import nodeMarquee from 'node-marquee';

class StrapTeaser {
    constructor ($element, options) {
        // Verhindere doppelte Initialisierung
        if ($element && $element.__strapTeaserInitialized) {
            return;
        }
        const defaults = {
            initAttr: 'data-strapteaser'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$strapTeaser = $element;
        this.$strapKeywords = this.$strapTeaser.querySelector(`[${this.settings.initAttr}="keywords"]`);

        if (!this.$strapKeywords) {
            this.initializationFailed = true;
            return; // Keine Animation ohne Ziel-Element
        }

        this.initialize();

        // Markiere als initialisiert
        this.$strapTeaser.__strapTeaserInitialized = true;
    }

    initialize () {
        this.initStrapAnimation();
    }

    initStrapAnimation () {
        if (this.initializationFailed) return;
        try {
            this.marquee = nodeMarquee({
                parent: this.$strapKeywords,
                speed: 0.4
            });
        } catch (err) {
            console.error('[StrapTeaser] Fehler beim Initialisieren', err);
        }
    }

    destroy () {
        if (this.marquee) {
            try {
                if (typeof this.marquee.stop === 'function') {
                    this.marquee.stop();
                }
            } catch (err) {
                console.error('[StrapTeaser] Fehler beim Stoppen der Marquee:', err);
            }
            this.marquee = null;
        }
        if (this.$strapTeaser) {
            delete this.$strapTeaser.__strapTeaserInitialized;
        }
    }
}

export { StrapTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$strapTeaser = $context.querySelectorAll('[data-strapteaser="root"]');
        for (let i = 0; i < $$strapTeaser.length; i++) {
            const $strapTeaser = $$strapTeaser[i];
            // Falls bereits eine API existiert, nicht erneut initialisieren
            if ($strapTeaser.API instanceof StrapTeaser) {
                continue;
            }
            const strapTeaserAPI = new StrapTeaser($strapTeaser);
            $strapTeaser.API = strapTeaserAPI;
        }
    }
});
